export default __webpack_public_path__ + "static/media/warning-icon.4a1a3e9f.svg";